module.exports = __webpack_public_path__ + "media/3_4-9.38d6d295.mp3";